/** The sentences of the «Datos» tab: what a retention run took, or would take, in words. */

/**
 * «se borrará el contenido de 12 correos, 12 ficheros originales y 340 anotaciones del
 * registro» (or «se ha borrado…»), listing only what is not zero, so a run that only
 * trimmed the log does not talk about correos.
 */
export function summary({
  bodies,
  rawFiles,
  attachments,
  accessLogRows,
  guidelines = 0,
  future,
}: {
  bodies: number;
  rawFiles: number;
  attachments: number;
  accessLogRows: number;
  /** Criteria learned from a note that no longer serve (contract v10.36). */
  guidelines?: number;
  /** Tense: what tonight's run will take, what «Ejecutar ahora» would, or what a run did. */
  future?: 'tonight' | 'now';
}): string {
  const parts: string[] = [];
  if (bodies > 0) parts.push(`el contenido de ${bodies} ${plural(bodies, 'correo', 'correos')}`);
  if (rawFiles > 0) {
    parts.push(`${rawFiles} ${plural(rawFiles, 'fichero original', 'ficheros originales')}`);
  }
  if (attachments > 0) {
    parts.push(`${attachments} ${plural(attachments, 'adjunto', 'adjuntos')}`);
  }
  if (accessLogRows > 0) {
    parts.push(
      `${accessLogRows} ${plural(accessLogRows, 'anotación del registro de accesos', 'anotaciones del registro de accesos')}`,
    );
  }
  if (guidelines > 0) {
    parts.push(
      `${guidelines} ${plural(guidelines, 'criterio aprendido que ya no vale', 'criterios aprendidos que ya no valen')}`,
    );
  }
  if (parts.length === 0) {
    return future ? 'No se borraría nada.' : 'No había nada que borrar.';
  }
  const list =
    parts.length === 1 ? parts[0] : `${parts.slice(0, -1).join(', ')} y ${parts[parts.length - 1]}`;
  const verb =
    future === 'tonight'
      ? 'Esta noche se borrará'
      : future === 'now'
        ? 'Al ejecutarla se borraría'
        : 'Se ha borrado';
  return `${verb} ${list}.`;
}

export function plural(count: number, one: string, many: string): string {
  return count === 1 ? one : many;
}
